import React, {useState, useEffect} from 'react';
import { parseISO, format } from 'date-fns';
import Page from 'components/Templates/Page';
import api from 'services/api';
import { useHistory, Link } from "react-router-dom";
import BtnTitle from 'components/BtnTitle';
import ItemAudiobook from 'components/ItemAudiobook';

export default function Audiobooks() {
    const history = useHistory();
    const [audiobooks, setAudiobooks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const loadAudiobooks = async () => {
            setIsLoading(true);
            try{
                const response = await api.get(`/admin/audiobooks`);
                setAudiobooks(response.data);
                setIsLoading(false);
            }catch(error){
                setIsLoading(false);
            }
        }
        loadAudiobooks();
    }, []);

    return (
        <Page name="audiobooks" loading={isLoading}>
            <h1>Audiobooks
                <BtnTitle label="Adicionar" iconName="plus-circle" handleOnClick={()=> history.push('/audiobooks/add') } />
            </h1>

            <div className="container">
                <table className="uk-table uk-table-striped uk-table-small  uk-table-middle">
                <thead>
                    <tr>
                        <th width="38">#</th>
                        <th width="200">Nome</th>
                        <th>Descrição</th>
                        <th width="130">Criado em:</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        audiobooks.map((audiobook, index) => (
                            <tr key={index}>
                                <td><ItemAudiobook color={audiobook.color} size={38} /></td>
                                <td><Link to={`/audiobooks/edit/${audiobook._id}`}>{audiobook.name}</Link></td>
                                <td>{audiobook.description}</td>
                                <td><i className='bx bx-calendar'></i>{format(parseISO(audiobook.createdAt), 'dd/M/Y')}</td>
                            </tr>
                        ))
                    }
                </tbody>
                </table>

            </div>

            
       </Page>
    )
}
